<script>
import { connect } from 'vuex-connect';
import GamesDetailsBox from '../scenes/GameDetailsBox.vue';

export default connect({
  gettersToProps: {
    game: 'detailGame',
    canStart: 'canStart',
    hasCalledHelp: 'hasCalledHelp',
  },
  stateToProps: {
    loading: state => state.launcher.loadings.getGame,
    waitingLaunch: state => state.launcher.loadings.launchingGame,
  },
  methodsToEvents: {
    cancel: ({ dispatch }, game) => {
      dispatch('confirmLaunchCancel', game);
    },
    launch: ({ dispatch }, id) => {
      dispatch('startGame', { id });
    },
  },
  lifecycle: {
    created ({ dispatch, state, getters }) {
      if (!getters.detailGame) {
        const gameId = state.route.params.gameId;
        dispatch('getGame', gameId);
      }
    },
  },
})('GamesDetailsBox', GamesDetailsBox);
</script>
